const initialState = {
    insurances: [],
};
const initialData = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_DATA_INITIAL_DATA':
           return {...state, [action.name]: action.value};
        default:
            return state;
    }
};

export default initialData;
